import {
  infoFetchEstadoValidacionNacionalI,
  makeEstadoValidacionNacional,
} from "dtos/estadoValidacionNacional";
import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  fetchingPropsI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";
import {
  infoFetchGetValidezNacional,
  makeValidezNacional,
} from "dtos/validezNacional";

export const getValidezNacional = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetValidezNacional>
  >({
    method: "GET",
    uri: ENDPOINTS.VALIDACION_NACIONAL,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  const elementosFormated = response.elementos.map((ctElemento) =>
    makeValidezNacional(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const getValidezNacionalExpedienteInterno = async (params: any) => {
  const response = await sendRequest<infoFetchGetValidezNacional>({
    method: "GET",
    uri: ENDPOINTS.VALIDACION_NACIONAL_EXPEDIENTE_INTERNO,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return {
    ...response,
  };
};

export const getValidezNacionalById = async (id: any, params?: any) => {
  const response = await sendRequest<infoFetchGetValidezNacional | undefined>({
    method: "GET",
    uri: ENDPOINTS.VALIDACION_NACIONAL + "/" + id,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return response ? makeValidezNacional(response) : undefined;
};

export const postValidezNacional = async ({
  params,
  images,
}: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetValidezNacional>({
    method: "POST",
    uri: ENDPOINTS.VALIDACION_NACIONAL,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeValidezNacional(response);
};

export const deleteValidezNacional = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.VALIDACION_NACIONAL + "/" + id,
  });
  return response;
};

export const putValidezNacional = async ({
  params,
  images,
}: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetValidezNacional>({
    method: "PUT",
    uri: ENDPOINTS.VALIDACION_NACIONAL,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeValidezNacional(response);
};

// export const getEstadoValidezNacional = async (params: any) => {
//   const response = await sendRequest<
//     getResponseWithPagination<infoFetchEstadoValidacionNacionalI>
//   >({
//     method: "GET",
//     uri: ENDPOINTS.ESTADO_VALIDACION_NACIONAL,
//     params: servicesUtils.removeNullParamsInFilters(params),
//   });
//   const elementosFormated = response.elementos.map((ctElemento) =>
//     makeEstadoValidacionNacional(ctElemento),
//   );
//   return {
//     ...response,
//     elementos: elementosFormated,
//   };
// };

export const getEstadoValidezNacional = async ({
  params,
  signal,
}: fetchingPropsI) => {
  const response = await sendRequest<infoFetchEstadoValidacionNacionalI[]>({
    method: "GET",
    uri: ENDPOINTS.ESTADO_VALIDACION_NACIONAL,
    params: servicesUtils.removeNullParamsInFilters(params),
    signal,
  });
  return response.map((ctElemento) => makeEstadoValidacionNacional(ctElemento));
};

export const getEstadoValidezNacionalById = async (id: any, params?: any) => {
  const response = await sendRequest<
    infoFetchEstadoValidacionNacionalI | undefined
  >({
    method: "GET",
    uri: ENDPOINTS.ESTADO_VALIDACION_NACIONAL + "/" + id,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return response ? makeEstadoValidacionNacional(response) : undefined;
};
